//创建一个静态的方法，用于返回一个固定的JSON结构

export function getChartRenderSchema(chartData: any): any {
    //如果存在script，就使用传入的script
    let script = '';
    let chartSchema = {
        id: 'beflamechart_chart',
        componentName: 'BeflamEchart',
        children: [],
        props: {},
        isLocked: false,
        title: '',
        ignore: false,
        hidden: false,
        condition: true,
        conditionGroup: '',
        defaultProps: null,
    };
    if (chartData.options) {
        chartSchema.props = {
            "style": {
                "flex": "1",
                "width": "100%"
            },
            "id": "chart",
            "options": {
                "type": "DataBinding",
                "bindingType": "Oneway",
                "value": "options"
            },
            "title": "",
            "axisLabelRotate": 0,
            "notMerge": true,
            "isStack": "",
            "isVerticalStack": true,
            "axisXText": "",
            "axisYText": "",
            "secondAxesYText": "",
            "gridLeft": "",
            "gridRight": "",
            "gridTop": "",
            "gridBottom": "",
            "isShowToolBox": true,
            isShowToolTip: true,
            "_unsafe_MixedSetter_value_select": "VariableSetter",
            _unsafe_MixedSetter_options_select: "VariableSetter",
            "value": {
                "type": "DataBinding",
                "bindingType": "Oneway",
                "value": "chartData"
            },
            "isShowArea": true,
            "isShowX": true,
            "isShowY": true,
            "isShowY1": true,
            "isShowLegend": true
        }

        script = `
let dataAdapter = page.createBizObject("${chartData.modelid}");
page.dataContext.chartData = [];
page.dataContext.options = ${chartData.options};

async function page_load(e, sender) {
	const totalResult = await dataAdapter.total({
		totalItems: ${JSON.stringify(chartData.totalItems)},
		data: {},
		queryWheres: ${JSON.stringify(chartData.queryWheres)}
	});
	page.dataContext.chartData = totalResult.Datas;
	page.dataBind();
}
    `;
    } else {
        chartSchema.props = {
            "style": {
                "flex": "1",
                "width": "100%"
            },
            "id": "chart",
            "options": "",
            "chartType": {
                "type": "DataBinding",
                "bindingType": "Oneway",
                "value": "chartType"
            },
            "title": "",
            "axisLabelRotate": 0,
            "xDimentsion": {
                "type": "DataBinding",
                "bindingType": "Oneway",
                "value": "xDimentsion"
            },
            "notMerge": true,
            "yDimentsion": {
                "type": "DataBinding",
                "bindingType": "Oneway",
                "value": "yDimentsion"
            },
            "isStack": "",
            "isVerticalStack": true,
            "axisXText": "",
            "axisYText": "",
            "secondAxesYText": "",
            "gridLeft": "",
            "gridRight": "",
            "gridTop": "",
            "gridBottom": "",
            "isShowToolBox": true,
            isShowToolTip: true,
            "_unsafe_MixedSetter_value_select": "VariableSetter",
            _unsafe_MixedSetter_chartType_select: "VariableSetter",
            _unsafe_MixedSetter_xDimentsion_select: "VariableSetter",
            _unsafe_MixedSetter_yDimentsion_select: "VariableSetter",
            "value": {
                "type": "DataBinding",
                "bindingType": "Oneway",
                "value": "chartData"
            },
            "isShowArea": true,
            "isShowX": true,
            "isShowY": true,
            "isShowY1": true,
            "isShowLegend": true
        }

        script = `
page.dataContext.chartType = "${chartData.chartType}";
page.dataContext.xDimentsion = "${chartData.xDimentsion}";
page.dataContext.yDimentsion = ${JSON.stringify(chartData.yDimentsion)};
page.dataContext.chartData = [];
let dataAdapter = page.createBizObject("${chartData.modelid}");

function getControl(name) {
    var result = page.getControl(name);
    if (result) {
        return result;
    } else {
        throw \`页面中不存在<name=\${name}>的控件！\`;
    }
}

async function page_load(e, sender) {
	const totalResult = await dataAdapter.total({
		totalItems: ${JSON.stringify(chartData.totalItems)},
		data: {},
		queryWheres: ${JSON.stringify(chartData.queryWheres)}
	});
	page.dataContext.chartData = totalResult.Datas;
	page.dataBind();
}

page.chatEvent = async (e, sender) => {
    try {
        if (!e) return;
        if (e.action === "PageAction" && e.data && e.data.chartType) {
            page.dataContext.chartType = e.data.chartType;
            page.dataBind();
        }
    } catch (err) {
        page.showError(err);
    }
};
    `
    }

    return {
        ChildrenSchema: {
            componentsTree: [
                {
                    id: 'page_f3f164b9c52b4b879c10c71d81433100',
                    componentName: 'Page',
                    props: {
                        ref: 'outerView',
                        style: {
                            height: '100%',
                        },
                    },
                    children: [
                        {
                            id: 'node_oclgn36ive1',
                            componentName: 'FDPage',
                            props: {
                                contentProps: {
                                    style: {
                                        background: 'rgba(255,255,255,0)',
                                    },
                                },
                                __events: {
                                    type: 'EventHandler',
                                    value: {
                                        load: 'page_load',
                                    },
                                },
                                style: {
                                    "backgroundColor": "rgba(255,255,255,0)",
                                    "display": "flex",
                                    "lineHeight": "21px"
                                }
                            },
                            children: [
                                {
                                    "id": "fdpageheader_bd0c53361343423784c81358fa90c6a4",
                                    "componentName": "FDPageHeader",
                                    "props": {
                                        "fullWidth": true,
                                        "style": {
                                            "backgroundColor": "rgba(255,255,255,0)"
                                        }
                                    },
                                    "children": [
                                        {
                                            "id": "fdrow_3fab1b42c0704347988f36b185d22338",
                                            "componentName": "FDRow",
                                            "props": {
                                                "gap": 24,
                                                "style": {
                                                    "paddingLeft": "24px",
                                                    "paddingRight": "24px",
                                                    "paddingTop": "24px"
                                                }
                                            },
                                            "children": [
                                                {
                                                    "id": "fdcell_pageTitle",
                                                    "componentName": "FDCell",
                                                    "props": {
                                                        "align": "center",
                                                        "verAlign": "top",
                                                        "style": {
                                                            "backgroundColor": "rgba(255,255,255,0)",
                                                            "display": "flex",
                                                            "flexDirection": "row",
                                                            "flex": 1,
                                                            "overflow": "auto"
                                                        }
                                                    },
                                                    "children": [
                                                        {
                                                            "id": "beflabel_pageTitleTitleText",
                                                            "componentName": "BefLabel",
                                                            "props": {
                                                                "id": "beflabel_pageTitleTitleText",
                                                                "content": chartData.title || chartData.text || "图表",
                                                                "_unsafe_MixedSetter_content_select": "StringSetter",
                                                                "style": {
                                                                    "color": "#262a2a",
                                                                    "fontSize": "18px",
                                                                    "fontWeight": 600,
                                                                    "marginLeft": "8px"
                                                                }
                                                            },
                                                            "children": [],
                                                            "isLocked": false,
                                                            "title": "",
                                                            "ignore": false,
                                                            "hidden": false,
                                                            "condition": true,
                                                            "conditionGroup": "",
                                                            "defaultProps": null
                                                        }
                                                    ],
                                                    "isLocked": false,
                                                    "title": "",
                                                    "ignore": false,
                                                    "hidden": false,
                                                    "condition": true,
                                                    "conditionGroup": "",
                                                    "defaultProps": null
                                                }
                                            ],
                                            "isLocked": false,
                                            "title": "",
                                            "ignore": false,
                                            "hidden": false,
                                            "condition": true,
                                            "conditionGroup": "",
                                            "defaultProps": null
                                        }
                                    ],
                                    "isLocked": false,
                                    "title": "",
                                    "ignore": false,
                                    "hidden": false,
                                    "condition": true,
                                    "conditionGroup": "",
                                    "defaultProps": null
                                },
                                {
                                    id: 'fdsection_160959f2212c4e93af89a251da486266',
                                    componentName: 'FDSection',
                                    props: {
                                        style: {
                                            backgroundColor: 'rgba(255,255,255,0)',
                                            minHeight: '',
                                            paddingBottom: '24px',
                                            paddingLeft: '24px',
                                            paddingRight: '24px',
                                            paddingTop: '24px',
                                        },
                                    },
                                    children: [
                                        {
                                            id: 'fdblock_ce7b2e9575a64ef3a65064cdfc975907',
                                            componentName: 'FDBlock',
                                            props: {
                                                mode: 'transparent',
                                                span: 12,
                                                style: {
                                                    backgroundColor: 'rgba(255,255,255,1)',
                                                },
                                            },
                                            children: [
                                                {
                                                    id: 'fdcell_aea2e534ac1e4aef91c1eb35a2941bb9',
                                                    componentName: 'FDCell',
                                                    props: {
                                                        align: 'left',
                                                        verAlign: 'top',
                                                        style: {
                                                            backgroundColor: 'rgba(255,255,255,1)',
                                                            minHeight: '',
                                                            flex: '1',
                                                        },
                                                        width: '',
                                                    },
                                                    children: [
                                                        chartSchema
                                                    ],
                                                    isLocked: false,
                                                    title: '容器',
                                                    ignore: false,
                                                    hidden: false,
                                                    condition: true,
                                                    conditionGroup: '',
                                                    defaultProps: null,
                                                },
                                            ],
                                            isLocked: false,
                                            title: '区块',
                                            ignore: false,
                                            hidden: false,
                                            condition: true,
                                            conditionGroup: '',
                                            defaultProps: null,
                                        },
                                    ],
                                    isLocked: false,
                                    title: '区域',
                                    ignore: false,
                                    hidden: false,
                                    condition: true,
                                    conditionGroup: '',
                                    defaultProps: null,
                                },
                            ],
                            isLocked: false,
                            title: '页面',
                            ignore: false,
                            hidden: false,
                            condition: true,
                            conditionGroup: '',
                            defaultProps: null,
                        },
                    ],
                    isLocked: false,
                    title: '',
                    ignore: false,
                    hidden: false,
                    condition: true,
                    conditionGroup: '',
                    defaultProps: null,
                },
            ],
            i18n: {
                'zh-CN': {},
                'en-US': {},
            },
        },
        Script: script,
        DataSourceData: [],
    };
}